import { AuthService } from "@app/service/auth.service";
import { UserService } from "@data/services/user/user.service";
import { LaunchdarklyService } from "@shared/services/LaunchDarkly/launchdarkly.service";
import { CookieService } from "ngx-cookie-service";
import { defaultIfEmpty, take } from "rxjs";
import { firstValueFrom } from 'rxjs';
import { LDF_ENABLE_SHARED_AUTH_COOKIE_DOMAIN } from '@app/constants';

export function initializeAppFactory(
  _authService: AuthService,
  _launchDarklySvc: LaunchdarklyService,
  _userSvc: UserService,
  _cookieService: CookieService,
): () => Promise<any> {

  return (): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      try {
        const currentPage = window.location.pathname;
        // Initialize LaunchDarkly before writing the auth cookie so the
        // shared-domain rollout can be disabled without redeploying.
        _launchDarklySvc.init(null);
        const useSharedCookieDomain = currentPage === '/registration.html'
          ? true
          : Boolean(await firstValueFrom(_launchDarklySvc.getFlag(LDF_ENABLE_SHARED_AUTH_COOKIE_DOMAIN, true)));

        if (currentPage !== '/registration.html')
          _authService.setCookie(useSharedCookieDomain);

        let userId = _authService?.getToken()?.user_id;
        if (userId)
          _userSvc.getUserView(userId)
            .pipe(take(1), defaultIfEmpty(null))
            .subscribe({
              next: userDetails => _launchDarklySvc.init(userDetails) ? resolve(true) : reject(false),
              error: () => _launchDarklySvc.init(null) ? resolve(true) : reject(false),
            })

        else
          _launchDarklySvc.init(null) ? resolve(true) : reject(false)


      } catch (error) {
        reject(error);
      }
    });
  };
};
